"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = function () {
    var itemsFilterButtonClick = function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(event) {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            try {
                                facetPopupFilter.setupFacetGroup(event.target, function () {
                                    // close previous dialog if is still shown
                                    showHideDialog(false);

                                    if (!getDialogElement(itemsDialogId)) return;
                                    facetPopupFilter.setDialog(dialog);

                                    showHideDialog(true);
                                    registerClosingEvents();
                                    facetPopupFilter.setFilteringLabel();
                                    facetPopupFilter.setUpUserFacetFiltering();
                                    facetPopupFilter.fillFilteringBody();
                                    registerItemsFilterButtonsClick();
                                });
                            } catch (e) {
                                console.error("Error in popup facets functionality.", e);
                            }

                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        return function itemsFilterButtonClick(_x) {
            return _ref.apply(this, arguments);
        };
    }();

    var facetFilterButtons = document.querySelectorAll('.facet-filter-button.popup-options');
    var facetDatePickerButtons = document.querySelectorAll('.facet-filter-button.popup-date-picker');
    var stockAvailabilityButtons = document.querySelectorAll('.facet-filter-button.popup-availability');

    var availabilityDialogId = 'facetAvailabilityPopup';
    var datePickerDialogId = 'facetDatePickerDialog';
    var itemsDialogId = 'facetFilteringDialog';
    var dialog = void 0;
    window.catalogPupupPushRegistered = false;
    var closingEventsRegistered = false;

    var availabilityFilter = new _availabilityFilter2.default(showHideDialog, highLightUsedAvailabilityFacets);
    var datePickerFilter = new _datePickerFilter2.default(showHideDialog);
    var facetPopupFilter = new _facetPopupFilter2.default(showHideDialog);

    if (!window.catalogPupupPushRegistered) {
        window.addEventListener('pushHistory', function () {
            if (facetFilterButtons) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(facetFilterButtons), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var button = _step.value;

                        var regex = facetPopupFilter.getFilterParamRegex(button.dataset.facetGroup);
                        labelUsedPopupFacets(regex, button);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            if (facetDatePickerButtons) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = (0, _getIterator3.default)(facetDatePickerButtons), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var dateButton = _step2.value;

                        highlightUsedFilterButton(dateButton);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            if (stockAvailabilityButtons) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = (0, _getIterator3.default)(stockAvailabilityButtons), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var availabilityButton = _step3.value;

                        highLightUsedAvailabilityFacets(availabilityButton);
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
        });
        window.catalogPupupPushRegistered = true;
    }

    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
        for (var _iterator4 = (0, _getIterator3.default)(stockAvailabilityButtons), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var availabilityButton = _step4.value;

            if (availabilityButton.clickRegistered) continue;
            availabilityButton.addEventListener('click', availabilityButtonClick);
            availabilityButton.clickRegistered = true;
            highLightUsedAvailabilityFacets(availabilityButton);
        }
    } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
            }
        } finally {
            if (_didIteratorError4) {
                throw _iteratorError4;
            }
        }
    }

    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
        for (var _iterator5 = (0, _getIterator3.default)(facetDatePickerButtons), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var datePickerButton = _step5.value;

            if (datePickerButton.clickRegistered) continue;
            datePickerButton.addEventListener('click', datePickerButtonClick);
            datePickerButton.clickRegistered = true;
            highlightUsedFilterButton(datePickerButton);
        }
    } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
            }
        } finally {
            if (_didIteratorError5) {
                throw _iteratorError5;
            }
        }
    }

    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
        for (var _iterator6 = (0, _getIterator3.default)(facetFilterButtons), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var itemsButton = _step6.value;

            if (itemsButton.clickRegistered) continue;
            itemsButton.addEventListener('click', itemsFilterButtonClick);
            itemsButton.clickRegistered = true;
            var regex = facetPopupFilter.getFilterParamRegex(itemsButton.dataset.facetGroup);
            labelUsedPopupFacets(regex, itemsButton);
        }
    } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
            }
        } finally {
            if (_didIteratorError6) {
                throw _iteratorError6;
            }
        }
    }

    function availabilityButtonClick(event) {
        // close previous dialog if is still shown
        showHideDialog(false);
        if (!getDialogElement(availabilityDialogId)) return;
        showHideDialog(true);
        registerClosingEvents();
        availabilityFilter.registerFilterClick(event);
        highLightUsedAvailabilityFacets(event.target);
    }

    function datePickerButtonClick(event) {
        // close previous dialog if is still shown
        showHideDialog(false);
        if (!getDialogElement(datePickerDialogId)) return;
        showHideDialog(true);
        registerClosingEvents();
        datePickerFilter.fillDatePickerValues();
        datePickerFilter.registerFilterByDateClick();
        highlightUsedFilterButton(event.target);
    }

    function getDialogElement(dialogId) {
        dialog = document.getElementById(dialogId);
        if (!dialog) {
            console.error("There is no element with Id: " + dialogId);
            return null;
        }
        return dialog;
    }

    // click to "Filter" button on popup (Authors, ProductType, PublishingHouse) 
    function registerItemsFilterButtonsClick() {
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
            for (var _iterator7 = (0, _getIterator3.default)(dialog.querySelectorAll('.popup-facet-filter-button')), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var filterButton = _step7.value;

                if (filterButton.clickRegistered) continue;

                filterButton.addEventListener('click', function (event) {
                    var currentFilterParamRegex = facetPopupFilter.getFilterParamRegex();
                    // update current URL and update search results
                    _common2.default.updateSearchQuery(currentFilterParamRegex, facetPopupFilter.selectedItems[facetPopupFilter.facetGroupName], facetPopupFilter.facetGroupName);
                    // highlight used filters
                    labelUsedPopupFacets(currentFilterParamRegex, event.target);
                    // hide popup
                    showHideDialog();
                });
                filterButton.clickRegistered = true;
            }
        } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                }
            } finally {
                if (_didIteratorError7) {
                    throw _iteratorError7;
                }
            }
        }
    }

    function highlightUsedFilterButton(button) {
        var filterQuery = _common2.default.loadObjectFilter();
        _common2.default.highLightActiveFilterButton(filterQuery.ReleaseFrom || filterQuery.ReleaseTo, button);
    }

    function labelUsedPopupFacets(regex, button) {
        var selectedItemsFromUrl = _common2.default.loadSelectedFiltersFromUrl(regex);
        _common2.default.highLightActiveFilterButton(selectedItemsFromUrl.length > 0, button);
    }

    function highLightUsedAvailabilityFacets(button) {
        if (!button) return;

        var filterObject = _common2.default.loadObjectFilter();
        var highLight = getAvailabilityOperatorSafe(filterObject.CustomAvailabilityOperator) > 0 && button.classList.contains('filter-button-my-state') || getAvailabilityOperatorSafe(filterObject.AvailabilityOperator) > 0 && button.classList.contains('filter-button-grada-state');

        _common2.default.highLightActiveFilterButton(highLight, button);
    }

    function getAvailabilityOperatorSafe(operatorUnsafeValue) {
        return _common2.default.testIntInString(operatorUnsafeValue) ? parseInt(operatorUnsafeValue) : 0;
    }

    function registerClosingEvents() {
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
            for (var _iterator8 = (0, _getIterator3.default)(dialog.querySelectorAll('.filtering-close-button')), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                var closeButton = _step8.value;

                if (closeButton.closingEventsRegistered) continue;

                closeButton.addEventListener('click', function () {
                    showHideDialog(false);
                });
                closeButton.closingEventsRegistered = true;
            }
        } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                    _iterator8.return();
                }
            } finally {
                if (_didIteratorError8) {
                    throw _iteratorError8;
                }
            }
        }

        if (!closingEventsRegistered) {
            // pressing Esc
            window.addEventListener('keydown', function (event) {
                if (event.code === 'Escape') showHideDialog();
            });

            // click outside
            document.addEventListener("click", function (evt) {
                var clickedElement = evt.target;

                do {
                    if (clickedElement === dialog || clickedElement.clickRegistered) return;
                    clickedElement = clickedElement.parentNode;
                } while (clickedElement);

                showHideDialog();
            });
            // do not register multiple times
            closingEventsRegistered = true;
        }
    }

    function showHideDialog() {
        var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        facetPopupFilter.filterString = facetPopupFilter.filteringLetter = null;
        if (dialog) dialog.style.display = show ? 'block' : '';
    }
};

var _common = require("../utils/common");

var _common2 = _interopRequireDefault(_common);

var _availabilityFilter = require("../modules/availabilityFilter");

var _availabilityFilter2 = _interopRequireDefault(_availabilityFilter);

var _datePickerFilter = require("../modules/datePickerFilter");

var _datePickerFilter2 = _interopRequireDefault(_datePickerFilter);

var _facetPopupFilter = require("../modules/facetPopupFilter");

var _facetPopupFilter2 = _interopRequireDefault(_facetPopupFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/catalogPopupFilters.js
// module id = 931
// module chunks = 0